import { render, staticRenderFns } from "./SaldoGrade.vue?vue&type=template&id=6e912058&scoped=true"
import script from "./SaldoGrade.vue?vue&type=script&lang=js"
export * from "./SaldoGrade.vue?vue&type=script&lang=js"
import style0 from "./SaldoGrade.vue?vue&type=style&index=0&id=6e912058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e912058",
  null
  
)

export default component.exports